// First the jQuery dependency
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
// import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
// import 'bootstrap/js/src/dropdown';
// import 'bootstrap/js/src/modal';
// import 'bootstrap/js/src/popover';
// import 'bootstrap/js/src/scrollspy';
// import 'bootstrap/js/src/toast';
// import 'bootstrap/js/src/tooltip';
import 'subnav';
import initButtonPixelTrail from './button-pixel-trail';

const runButtonPixelTrail = () => {
    initButtonPixelTrail();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runButtonPixelTrail, { once: true });
} else {
    runButtonPixelTrail();
}
